import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Footer from 'components/Footer/Footer';
import './style.css';
import PKimg from 'Assets/pksuccess.svg';
import { Container, Row, Col } from 'react-bootstrap';
//import Button from "components/Button/Button";
import Button from "react-bootstrap/Button";
// import Table from 'react-bootstrap/Table';
import { owner_perms, org_name, user_access_level, org_friendly_url, user_entity_uuid, user_Status } from "Api/Api";
// organization_user_access_level, user_account_level, apiUrl, searchUrl, user_API, , user_Status_Ver, presentation_Creation_API, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control
// import axios from "axios";
//import { getKey, dateConvert, unixDateConversion,origin, current_unix_stamp } from 'utils/Helper';
import { getKey } from 'utils/Helper';
// dateConvert, unixDateConversion, get_current_unix_stamp 
// import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
// import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import PkList from 'components/PkListTable/PkList';
//import PkListTable from 'components/PkListTable/PkListTable';
//import PkListTableV2 from 'components/PkListTable/PkListTableV2';
import { withRouter, Link } from "react-router-dom";
// import TableHeader from 'components/Table/TableHeaderV2';
import home from 'Assets/home.svg';
import { local_routes } from 'utils/Routes';

class MyPks extends Component {
    constructor(props) {
        super(props)
        this.state = {
            table_loading: true,
            loading: true,
            presentations_get_from: 0,
            presentations_get_limit: 20,
            presentations_get_total: null,
            presentations_array: [],
            presentations_page_number: 1,
            //loading: true,
            tableHeader: { 'Title': '', 'Event': '', 'Created On': '', 'Notes': '', 'Published': '', 'Privacy': '', 'Assets': '', 'Edit': '' },
            
            draftData: [],
            publishData: [],
            date: [],
            //pageLoader: true,
            validated: false,
            //pkLink: '',
            copied: false,
            //pendingData:[],
            //friendlyPkUrl:null,
            status_code:null,
            messages:[],
            //community_events_by_format: {}
        }
        
        this.workspace_base_url = "";
        this.workspace_indicator = '';
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
          //this.state.tableHeader = { 'Title': '', 'Event': '', 'Created On': '', 'Notes': '', 'Public': '' }
          this.workspace_indicator = <span data-tip="Want to create public presentations? Switch to Public View in upper right" style={{ verticalAlign: 'text-top', fontSize: "small" }} >&nbsp;&bull;&nbsp;{org_name} View</span>;
        } else {
            if (user_access_level === 'admin' || owner_perms.organizations) {
                this.workspace_indicator = <span data-tip="Want to create private presentations? Switch to Team View in upper right" style={{ verticalAlign: 'text-top', fontSize: "small" }} >&nbsp;&bull;&nbsp;Public View</span>;
            }
        }
        
        this.auto_refresh_time = 30; // seconds
        
        //this.interval = setInterval(() => this.setState({ time: Date.now() }), 5000);
    }
    
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    
    
    // Api Integration Strats here
    componentDidMount() {
        console.log("MyPks componentDidMount");
        //if (this.props.friendlyurl !== undefined && !null) {
        //    this.setState({ friendlyPkUrl: this.props.friendlyurl,  pkLink:`${origin}/player/${this.props.friendlyurl}` })
        //}
        //window.scrollTo(0, 0);
        //this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
        
        
        if (user_Status === 1) {
            //this.userPkMet();
            this.APICalls();
            this.interval = setInterval(() => this.APICalls(), this.auto_refresh_time * 1000);
        } else {
            //this.setState({ pageLoader: true })
            window.location.href = '/';
        }
    }

    APICalls = async (config = {}) => {
        console.log("MyPks APICalls",config);

        let new_state = {...this.state};

        if (getKey('PKListMessage')) {
            new_state.messages = getKey('PKListMessage');
            window.localStorage.removeItem('PKListMessage');
        } else {
            new_state.messages = [];
        }

        this.setState(new_state);
    }

    

    render() {


            return (
                <React.Fragment>
                <Helmet>
                    <title>My PechaKucha Presentations</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <React.Fragment>
                    <div>
                        <div className="pkListContainer">
                            <Container className="my-pk-list">
                                {this.state.messages && this.state.messages.messages && this.state.messages.messages.length > 1 ?
                                    <div className="pk-successfully">
                                        <div className="your-pk-data">
                                            <div className="img-div">
                                                <img src={PKimg} alt="img"/>
                                            </div>
                                            <h2 className="success-heading">{this.state.messages.messages[0]}</h2>
                                            <p>{this.state.messages.messages[1]}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                <Row style={{ marginTop: "20px"}}>
                                  <Col xs={8}>
                                    <h2 style={{ fontWeight: '600', display: 'inline' }} className="pklist-header">My PechaKucha Presentations</h2>{this.workspace_indicator}
                                  </Col>
                                  <Col xs={4} className="flex justify-content-end">
                                        <Link to={`${this.workspace_base_url}${local_routes.pkcreation}`}>
                                            <Button
                                              //theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 pk-create"
                                              variant="pkprimary"
                                              className="pklist-create-presentation-button"
                                            >
                                              Create Presentation
                                            </Button>
                                        </Link>

                                  </Col>
                                </Row>
                                {/*
                                <div className="myPkList">
                                    <div>
                                        <h2 style={{ fontWeight: '600', display: 'inline' }}>My PechaKucha Presentations</h2>{this.workspace_indicator}
                                    </div>
                                    <div className="buttonS pk-create-btn">
                                        <a href={`${this.workspace_base_url}${local_routes.pkcreation}`}>
                                            <Button
                                              //theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 pk-create"
                                              variant="pkprimary"
                                              size="lg"
                                            >
                                              Create Presentation
                                            </Button>
                                        </a>
                                    </div>
                                </div>
                                */}
                                <PkList
                                  //user_data={this.user_data}
                                  source_info={{entity_uuid: user_entity_uuid,entity_type:'users'}}
                                  referrer={`${this.workspace_base_url}${local_routes.pklist}`}
                                />
 
                            </Container>
                        </div>
                        <div style={{display:'block'}} className="myPkFooter">
                            <Footer
                            homeImg={home}
                            homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
                            breadcrumbSubPage="My PKs"/>
                        </div>
                    </div>
                </React.Fragment>
                </React.Fragment>
            );

    }
}

export default withRouter(MyPks);
